import { render, staticRenderFns } from "./OffersCriterasInfo.vue?vue&type=template&id=573470e2&scoped=true"
import script from "./OffersCriterasInfo.vue?vue&type=script&lang=js"
export * from "./OffersCriterasInfo.vue?vue&type=script&lang=js"
import style0 from "./OffersCriterasInfo.vue?vue&type=style&index=0&id=573470e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573470e2",
  null
  
)

export default component.exports